
export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  
  newState.settings = {...storeState.settings, ...payload};

  return newState;
};
